import { BudgetPlanLearnMore } from "../../Legal/LearnMore/BudgetPlanLearnMore";
import { ExploringBenefitsLearnMore } from "../../Legal/LearnMore/ExploringBenefitsLearnMore";
import { LegalDocumentsLearnMore } from "../../Legal/LearnMore/LegalDocumentsLearnMore";
import { LongTermCarePlanLearnMore } from "../../Legal/LearnMore/LongTermCarePlanLearnMore";
import ComingSoonPlaceholder from "../../../../Assessment/ComingSoonPlaceholder";
import OrganizingDocumentsLearnMore from "../../Legal/LearnMore/OrganizingDocumentsLearnMore";
import PropertyReviewLearnMore from "../../Legal/LearnMore/PropertyReviewLearnMore";
import FamilyHeirloomsLearnMore from "../../Legal/LearnMore/FamilyHeirloomsLearnMore";
import CareOfDependentsLearnMore from "../../Legal/LearnMore/CareOfDependentsLearnMore";
import PreventingFraudLearnMore from "../../Legal/LearnMore/PreventingFraudLearnMore";

export interface LegalLearnMoreFactoryProps {
  infoSlideIndex: number;
  navigateToDocuments: () => void;
}

export const LegalLearnMoreFactory: React.FC<LegalLearnMoreFactoryProps> = ({
  infoSlideIndex,
  navigateToDocuments
}) => {
  switch (infoSlideIndex) {
    case 0: {
      return (
        <LegalDocumentsLearnMore />
      );
    }
    case 1: {
      return (
        <BudgetPlanLearnMore />
      );
    }
    case 2: {
      return (
        <ExploringBenefitsLearnMore />
      );
    }
    case 3: {
      return (
        <LongTermCarePlanLearnMore />
      );
    }
    case 4: {
      return (
        <OrganizingDocumentsLearnMore navToDocs={() => navigateToDocuments()} />
      );
    }
    case 5: {
      return (
        <PropertyReviewLearnMore />
      );
    }
    case 6: {
      return (
        <FamilyHeirloomsLearnMore />
      );
    }
    case 7: {
      return (
        <CareOfDependentsLearnMore />
      );
    }
    case 8: {
      return (
        <PreventingFraudLearnMore />
      );
    }
    default: {
      return (
        <ComingSoonPlaceholder />
      );
    }
  }
};
